import { useState } from 'react';
import { withErrorBoundary } from '@sentry/react';
import { ErrorFallback } from './error-fallback';
import { InsuranceReport } from './InsuranceReport';

type InsuranceEligibilityReportProps = {
  reportProps: {
    locationId: string;
    personId: string;
    sourceId?: string;
    personPMSId?: string;
    closeInsuranceReportModal: () => void;
  };
};
const InsuranceEligibilityReport = ({ reportProps }: InsuranceEligibilityReportProps) => {
  const { locationId, personId, sourceId, personPMSId, closeInsuranceReportModal } = reportProps;

  const [shouldShowErrorFallback, setShouldShowErrorFallback] = useState<boolean>(false);

  if (shouldShowErrorFallback) return <ErrorFallback />;
  return (
    <InsuranceReport
      locationId={locationId ?? ''}
      sourceId={sourceId ?? ''}
      personId={personId ?? ''}
      personPMSId={personPMSId ?? ''}
      closeInsuranceReportModal={closeInsuranceReportModal}
      onError={() => setShouldShowErrorFallback(true)}
    />
  );
};

export const InsuranceReportPageWithErrorBoundary = withErrorBoundary(InsuranceEligibilityReport, {
  fallback: <ErrorFallback />,
});
